import React from 'react'
import ReactDOM from 'react-dom'

import DynamicList from './dynamic-list'

import AlgoliaSwitcher from './algolia-switcher'
import TypeaheadSwitcher from './typeahead-switcher'
import TypeaheadSelectWidget from './typeahead-select-widget'

window.React = React
window.ReactDOM = ReactDOM

window.DynamicList = DynamicList

window.AlgoliaSwitcher = AlgoliaSwitcher
window.TypeaheadSwitcher = TypeaheadSwitcher
window.TypeaheadSelectWidget = TypeaheadSelectWidget



// WEBPACK FOOTER //
// ./src/index.js